import { ICategory } from '../../types';
import React from 'react';
import { useTrail, animated } from 'react-spring';
import { getMediaUrl } from '@orderingstack/front-hooks';

interface CategoriesProps {
  categories?: ICategory[];
  selectedCategoryId?: string;
  onSelect: (category: ICategory) => void;
  fallbackImg: string;
}

export default function Categories({
  categories,
  selectedCategoryId,
  onSelect,
  fallbackImg,
}: CategoriesProps) {
  const trail = useTrail(categories?.length || 0, {
    opacity: 1,
    x: 0,
    height: 120,
    from: { opacity: 0, x: 20, height: 0 },
    config: { mass: 5, tension: 2000, friction: 200 },
  });
  if (!categories) {
    return null;
  }
  return (
    <div className=" overflow-y-auto">
      {trail.map(({ x, height, ...rest }, index) => {
        const category = categories[index];
        const { name, id, img } = category;
        const isSelected = id === selectedCategoryId;
        return (
          <animated.button
            key={id}
            style={{
              height,
              ...rest,
              transform: x.interpolate((x) => `translate3d(0,${x}px,0)`),
            }}
            className={`text-left block w-full pr-[1px]`}
            id={`chip-lg-${id}`}
            onClick={() => {
              onSelect(category);
            }}
          >
            <div
              className={`relative flex flex-row h-full items-center ${
                isSelected ? 'bg-bgColor-btnSecondary' : ''
              }`}
            >
              {isSelected && (
                <div className="absolute top-0 left-0 w-2 h-full bg-secondary" />
              )}
              <img
                alt=""
                className="mx-6 w-12"
                src={getMediaUrl(img || fallbackImg, 48)}
              />
              <span className="text-menuCategory">{name}</span>
            </div>
          </animated.button>
        );
      })}
    </div>
  );
}
